//-- React Standard
import { Badge, Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Fade, Row, FormGroup, Label, Input } from 'reactstrap';
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import { withStyles } from "@material-ui/core/styles";
import { apiConstants } from '../../_constants/api.constants';
import { userActions } from "../../_actions";

//-- CSS for Material
const styles = theme => ({
    error: {
        width: "auto",
        margin: "0 auto",
        background: "#ffbeba",
        padding: "10px 15px",
        marginTop: "50px",
        border: "2px solid #c71a0d",
        borderRadius: "9px",
        fontWeight: "bold"
    },     
    success: {
        width: "auto",
        margin: "0 auto",
        background: "#cbf5cb",
        padding: "10px 15px",
        marginTop: "50px",
        border: "2px solid green",
        borderRadius: "9px",
        fontWeight: "bold"
    }    
});

class AccountActivation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updated : '',
            expired : ''
        };
    }


    componentDidMount(){
        const { dispatch } = this.props;
        const { match } = this.props;
        const securitycode = match.params.securitycode;
        const obj = {};
        obj.securityCode = securitycode;
        dispatch(userActions.activateAccount(apiConstants.USER_ACCOUNT_ACTIVATION, obj));
    }

    componentWillReceiveProps(props){
        const { dispatch } = props;
        
        if(props.accountActivation){
            if(props.accountActivation.data !== undefined &&
            props.accountActivation.data.data !== undefined && 
            props.accountActivation.data.data.msg == 'Account Activate successfully.' ){
                this.setState({ updated : true });
            }
        }

        if(props.accountActivation){
            if(props.accountActivation.data !== undefined &&
            props.accountActivation.data.data !== undefined && 
            props.accountActivation.data.data.msg == 'link expired.' ){
                this.setState({ expired : true });
            }
        }
         
    }
 

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { classes } = this.props;

        return (
            <div id="wrapper">
                {
                    this.state.updated === true && this.state.updated !== '' ?  
                        <p class={classes.success}>{siteConstants.ACCOUNT_VERIFIED}</p>
                        : 
                        ""
                }

                {
                    this.state.expired === true && this.state.expired !== ''?  
                        <p class={classes.error}>{siteConstants.LINK_EXPIRED}</p>
                        : 
                        ""
                }



            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, accountActivation  } = state;
    return { language, accountActivation };
}

const connectedActivation = connect(mapStateToProps)(withStyles(styles)(AccountActivation));
export { connectedActivation as AccountActivation };